<script>
export default {
  name: 'StayType',
  data() {
    return {
      stay_type: {
        stay_typ_name: '',
      },
    }
  },
  mounted() {
  },
  methods: {
    newStayType() {
      this.$axios.post(this.$endpoint.CreateStayType, this.stay_type)
    },

  },
}
</script>

<template>
  <div>
    <v-row>
      <v-col
          cols="12"
          md="12"
      >
            <span
                class="text-lg-h5  mb-4"
                style="justify-content: center; display: flex;"
            >
              Nouveau type de séjour
            </span>
      </v-col>
    </v-row>
    <v-form
        class="multi-col-validation"
        style="margin-top:1rem; margin-left: 1rem; margin-bottom: 1.5rem;"
    >
      <v-row>
        <v-col
            cols="12"
            md="6"
        >
          <v-text-field
              v-model="stay_type.stay_typ_name"
              dense
              hide-details
              label="Nom"
              outlined
              placeholder="Nom du type de sejour"
          ></v-text-field>
        </v-col>

        <v-col
            cols="12"
            md="6"
        >
        </v-col>

        <v-col
            cols="12"
            md="6"
        >
        </v-col>

        <v-col cols="12">
        </v-col>

        <v-col cols="12">
          <v-btn
              color="primary"
              @click="newStayType"
          >
            Creer
          </v-btn>
          <v-btn
              class="mx-2"
              outlined
              type="reset"
          >
            Annuler
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<style scoped>

</style>